declare namespace $ {

	type $mol_button_minor__title_shm_hitalama_file_attach_pb_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_file_attach_pb_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_file_attach_pb['upload_cancel'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_status__message_shm_hitalama_file_attach_pb_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_file_attach_pb['upload_message'] >
		,
		ReturnType< $mol_status['message'] >
	>
	type $mol_status__style_shm_hitalama_file_attach_pb_4 = $mol_type_enforce<
		({ 
			'color': ReturnType< $shm_hitalama_file_attach_pb['status_color'] >,
		})  & ReturnType< $mol_status['style'] >
		,
		ReturnType< $mol_status['style'] >
	>
	export class $shm_hitalama_file_attach_pb extends $shm_hitalama_file_attach {
		upload_cancel( next?: any ): any
		Cancel( ): $mol_button_minor
		cancel_visible( ): readonly(any)[]
		delete_visible( ): readonly(any)[]
		upload_message( next?: string ): string
		status_color( ): string
		Status( ): $mol_status
		uploading( next?: boolean ): boolean
		deleting( next?: boolean ): boolean
		map_id( ): string
		widget_id( ): string
		field_name( ): string
		form_reset( ): any
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=pb.view.tree.d.ts.map